import { Button, Divider, TextField } from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { VIEW_MODE } from '../../../consts/enums';
import STRING_KEYS from '../../../language/keys';
import { EmailDomainTextField } from '../../common/textFields/EmailDomainTextField';
import { SubdomainTextField } from '../../common/textFields/SubdomainTextField';
import { AssociatedCompanySection } from '../AssociatedCompanySection';
import { AssociatedCompany } from '../../../@types/Account';
import { style } from './style';

type CreateNewAccountContentProps = {
  associatedCompany: AssociatedCompany | undefined,
  linkedinUrl: string,
  subDomainName: {
    error?: boolean,
    helperText?: string | false | undefined,
    value: string,
  },
  displayName: {
    error?: boolean,
    helperText?: string | false | undefined,
    value: string,
  },
  allowedEmailDomain: {
    error?: boolean,
    helperText?: string | false | undefined,
    value: string,
  },
  onValuesChange: (name: string, value: string) => void,
  onChangeCompanyClicked: () => void,
}

export const CreateNewAccountContent = ({
  associatedCompany,
  linkedinUrl,
  displayName,
  subDomainName,
  allowedEmailDomain,
  onValuesChange,
  onChangeCompanyClicked,
}:CreateNewAccountContentProps):JSX.Element => {
  const { t: translate } = useTranslation();
 
  return (
    <Box sx={ style.container }>
      <Box sx={ style.dialogContent.row }>
        <AssociatedCompanySection
          name={ associatedCompany?.name || 'No company' }
          logo={ associatedCompany?.logo || '' }
          isDisabled
          isLoading={ false }
          linkedinUrl={ linkedinUrl }
          showIconLinkedin
          viewMode={ VIEW_MODE.EDITABLE }
        />
        <Button
          variant="text"
          onClick={ onChangeCompanyClicked }
        >
          {translate(STRING_KEYS.CHANGE)}
        </Button>
      </Box>
      <Divider sx={ style.divider } />
      <TextField
        variant="outlined"
        label={ translate(STRING_KEYS.ACCOUNTS_NAME) }
        fullWidth
        sx={ style.Typography.sx }
        value={ displayName.value }
        name="displayName"
        placeholder={ translate(STRING_KEYS.ACCOUNTS_NAME) }
        onChange={ (e) => onValuesChange('displayName', e.target.value) }
        error={ displayName.error }
        helperText={ displayName.helperText ?
          displayName.helperText : '' }
      />
      <SubdomainTextField
        onChange={ onValuesChange }
        subDomainFields={ subDomainName }
        viewMode={ VIEW_MODE.EDITABLE }
      />
      <EmailDomainTextField
        onChange={ (value) => onValuesChange('allowedEmailDomain', value) }
        value={ allowedEmailDomain.value }
        helperText={ allowedEmailDomain.helperText ?
          allowedEmailDomain.helperText : '' }
        error={ allowedEmailDomain.error }
      />
    </Box>
  );
};
